import React, { useState } from "react";
import { Briefcase, ShieldCheck, Sparkles, Loader2 } from "lucide-react";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

const GOALS = [
  { id: "job_prep", icon: Briefcase, title: "Land a Job", desc: "I want AI mock interviews, case studies & recruiter visibility." },
  { id: "certification", icon: ShieldCheck, title: "Get Certified", desc: "I want to complete all 30 days and earn my verified certificate." },
  { id: "skill_up", icon: Sparkles, title: "Skill Up", desc: "I'm exploring Data Cloud hands-on — simulator, SQL & duels." },
];

export function OnboardingModal() {
  const { user, refreshUser } = useAuth();
  const [saving, setSaving] = useState(false);
  const [selected, setSelected] = useState(null);

  if (!user || user.role !== "user" || user.onboarding_completed) return null;

  const submit = async (goalId) => {
    setSelected(goalId);
    setSaving(true);
    try {
      await api.put("/users/me/onboarding", { goal: goalId });
      await refreshUser();
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center bg-black/70 backdrop-blur-sm px-4" data-testid="onboarding-modal">
      <div className="glass-panel rounded-2xl p-8 max-w-lg w-full border border-indigo-400/20">
        <div className="text-center mb-6">
          <h2 className="font-heading text-xl sm:text-2xl font-semibold text-white">What brings you here, {user.name?.split(" ")[0]}?</h2>
          <p className="text-sm text-slate-400 mt-2">We'll tailor your dashboard and AI recommendations around your goal.</p>
        </div>
        <div className="space-y-3">
          {GOALS.map((g) => {
            const Icon = g.icon;
            const isActive = selected === g.id;
            return (
              <button
                key={g.id}
                onClick={() => submit(g.id)}
                disabled={saving}
                data-testid={`onboarding-goal-${g.id}`}
                className={`w-full flex items-center gap-4 text-left rounded-xl p-4 border transition-colors disabled:opacity-60 ${
                  isActive ? "border-indigo-400/60 bg-indigo-400/10" : "border-white/10 bg-white/5 hover:border-indigo-400/30 hover:bg-white/[0.07]"
                }`}
              >
                <div className="w-10 h-10 rounded-lg bg-primary/15 flex items-center justify-center shrink-0">
                  {isActive && saving ? <Loader2 className="w-4 h-4 text-indigo-300 animate-spin" /> : <Icon className="w-5 h-5 text-indigo-300" />}
                </div>
                <div>
                  <p className="text-sm font-semibold text-white">{g.title}</p>
                  <p className="text-xs text-slate-400 mt-0.5">{g.desc}</p>
                </div>
              </button>
            );
          })}
        </div>
      </div>
    </div>
  );
}
